import { Tabs } from 'antd';
import React, { useEffect, useState } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { DI, DIProps } from '../../../../../Core';
import SandboxApi from './SandboxApi';



const SandboxSettings = (props: DIProps) => {
    const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth < 768);
    const tabsArray = ['sandbox']
    let tabForPath = tabsArray.indexOf(tabsArray.includes(props.match?.["*"] ?? 'sandbox') ? props.match["*"] : 'sandbox')
    const [selected, setSelected] = useState(tabForPath);
    useEffect(() => {
        const handleResize = () => {
            setIsSmallScreen(window.innerWidth < 991);
        };

        window.addEventListener('resize', handleResize);

        // Clean up the event listener
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    const tabs = [
        {
            key: 'sandbox',
            id: 'sandbox',
            label: 'Sandbox',
            children: <SandboxApi />,
        },
    ]

    return <div >
            <Tabs
                tabPosition={isSmallScreen ? "top" : "left"}
                onChange={(e) => { setSelected(tabsArray.indexOf(e)); props.history(e) }}
                items={tabs}
                activeKey={tabsArray[selected]}
                destroyInactiveTabPane
            />
            {/* <Routes>
                <Route path={tabsArray[selected]} element={<></>} />
                <Route path='*' element={<Navigate to={'sandbox'} />} />
            </Routes> */}
        </div>
       
    
}

export default DI(SandboxSettings);